// extracted by mini-css-extract-plugin
export default {"menu":"navbar_menu__QhVI1","mobileLockHeight":"navbar_mobileLockHeight__a65bd"};